import {WBIcon} from '@wandb/ui';
import classNames from 'classnames';
import React from 'react';
import makeComp from '../../util/profiler';
import * as S from './PanelError.styles';

type PanelErrorProps = {
  message: React.ReactChild;
  className?: string;
};

const PanelError: React.FC<PanelErrorProps> = makeComp(
  ({message, className}) => {
    return (
      <div className={classNames('panel-error', className)}>
        <div>
          <S.IconWrapper>
            <WBIcon name="info" />
          </S.IconWrapper>
          <div>{message}</div>
        </div>
      </div>
    );
  },
  {id: 'PanelError', memo: true}
);
export default PanelError;
